
    <a
      *ngIf="label | filled"
      [routerLink]="segments"
      [target]="(openNewTab) ? '_blank' : '_self'"
    >
      <div class="d-flex d-flex-gap align-items-center">
        <span>{{ label | translate}}</span>
      </div>
    </a>

    <span *ngIf="label | blank">--</span>
  